import React from "react";
import DesktopNav from "./DesktopNav";
import MobileNav from "./MobileNav";

const NavBar = ({isSidenavOpen, toggleSidenav}) => {
  return (
    <>
      <div className="hidden md:block">
        <DesktopNav />
      </div>
      <div className="md:hidden">
        <MobileNav isSidenavOpen={isSidenavOpen} toggleSidenav={toggleSidenav} />
      </div>
    </>
  );
};

export default NavBar;
